import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const SalesByLocationChart = ({ salesByLocation, loading }) => {
    // Donut chart data configuration
    const donutChartData = {
        labels: salesByLocation && salesByLocation.length > 0 
            ? salesByLocation.map(location => location.location_name?.en || '-')
            : ['-'],
        datasets: [
            {
                data: salesByLocation && salesByLocation.length > 0 
                    ? salesByLocation.map(location => location.order_count)
                    : [0],
                backgroundColor: [
                    '#10B981', // Green
                    '#3B82F6', // Blue
                    '#F59E0B', // Orange
                    '#EF4444', // Red
                    '#8B5CF6', // Purple
                    '#06B6D4', // Cyan
                ],
                borderColor: [
                    '#10B981',
                    '#3B82F6',
                    '#F59E0B',
                    '#EF4444',
                    '#8B5CF6',
                    '#06B6D4',
                ],
                borderWidth: 2,
            },
        ],
    };

    const donutChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false, // We'll use custom legend
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        const label = context.label || '';
                        const value = context.parsed;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = ((value / total) * 100).toFixed(1);
                        return `${label}: ${value} orders (${percentage}%)`;
                    }
                }
            },
            datalabels: {
                display: true,
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 14
                },
                formatter: function(value, context) {
                    // Only show labels for segments with significant size
                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                    const percentage = (value / total) * 100;
                    return percentage > 5 ? value : ''; // Only show if > 5%
                },
                anchor: 'center',
                align: 'center'
            }
        },
        cutout: '80%', // Makes it a donut chart
    };

    const colors = ['#10B981', '#3B82F6', '#F59E0B', '#EF4444', '#8B5CF6', '#06B6D4'];

    return (
        <div className="gender-chart h-100">
            <div className="chart-header mb-3">
                <h3 className="title mb-0">Sales by Customer Location (This Month)</h3>
            </div>
            <div className="chart-container mb-4" style={{ height: '300px' }}>
                {loading ? (
                    <div className="placeholder-chart d-flex align-items-center justify-content-center h-100 rounded"
                        style={{ background: 'rgba(16, 185, 129, 0.1)' }}>
                        <div className="spinner-border text-success" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="chart-wrapper h-100">
                        <Doughnut 
                            data={donutChartData} 
                            options={donutChartOptions}
                        />
                    </div>
                )}
            </div>
            <div className="chart-legend d-flex flex-column gap-3">
                {salesByLocation && salesByLocation.length > 0 ? (
                    salesByLocation.map((location, index) => (
                        <div key={location.location_id || index} className="legend-item d-flex align-items-center">
                            <span className="dot me-2" style={{ 
                                backgroundColor: colors[index % colors.length], 
                                width: '12px', 
                                height: '12px', 
                                borderRadius: '50%' 
                            }}></span>
                            <span className="label">{location.location_name?.en || '-'}</span>
                            <span className="value ms-auto">
                                {location.percentage}%
                            </span>
                        </div>
                    ))
                ) : (
                    // Fallback legend when no data
                    <div className="legend-item d-flex align-items-center">
                        <span className="dot me-2" style={{ 
                            backgroundColor: '#10B981', 
                            width: '12px', 
                            height: '12px', 
                            borderRadius: '50%' 
                        }}></span>
                        <span className="label">-</span>
                        <span className="value ms-auto">0%</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SalesByLocationChart;
